import { render, staticRenderFns } from "./parkingAppeal.vue?vue&type=template&id=084140b1&scoped=true"
import script from "./parkingAppeal.vue?vue&type=script&lang=js"
export * from "./parkingAppeal.vue?vue&type=script&lang=js"
import style0 from "./parkingAppeal.vue?vue&type=style&index=0&id=084140b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084140b1",
  null
  
)

export default component.exports